export const common = {
  name: 'Name',
  cancel: 'Cancel',
  ok: 'Ok',
  emailAddress: 'Email address',
  translateFrom: 'Translate from',
  translateTo: 'Translate to',
  noOfWords: 'No. of words',
  next: 'Next',
  noResultFound: 'No result Found',
  orderNow: 'Order Now',
  orderOnline: 'Order Online',
  uploadDocument: 'Upload document',
  uploadFiles: 'Upload files',
  submit: 'Submit',
  search: 'Search...',
  updateEmail: 'Update email',
  updateEmailSuccess: 'Your email has been successfully updated',
  phoneNumber: 'Phone number',
  comments: 'Comments',
  no: 'No',
  yes: 'Yes',
  tryAgain: 'Try again',
  errorMessage:
    'Something went wrong, please try again or email <a href="mailto:main@absolutetranslations.com">main@absolutetranslations.com</a>',
  details: 'Details: ',
  absoluteTranslation: 'Absolute Translations',
  pageNotFound: 'Page not found',
  yourLanguges: 'Your languages',
  addMoreLanguages: 'add more languages',
  yourDetails: 'Your details',
  sendYouEmail: 'So we can send you an email with your quote. No spam, ever.',
  phoneNumberOptional: 'Phone number (optional)',
  documentDetails: 'Document details',
};
